import httpInstance from '../../httpInstance';

const getReferralService = async () => {
  let res;
  const endpoint = '/referrals/v1/promos/1';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getReferralService;
